<template>
  <v-dialog v-model="show" persistent width="400">
    <v-card>
      <v-card-title>
        <v-icon class="mr-2">mdi-headset</v-icon>
        {{$t('buddy.bargein.title')}}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-radio-group v-model="bargeMode" class="ml-8">
          <v-radio v-for="opt in opts" :key="opt.val" :value="opt.val">
            <template v-slot:label>
              <v-icon class="mr-3">mdi-{{opt.icon}}</v-icon>
              <cp-help :i18n="opt.hlp"/>
              <span class="ml-1">{{opt.lbl}}</span>
            </template>
          </v-radio>
        </v-radio-group>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" text color="blue-grey">
          {{$t('buddy.bargein.cancel')}}
        </v-btn>
        <v-btn @click="start" text color="indigo">
          {{$t('buddy.bargein.start')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'call-bargin-form',
  data () {
    return {
      bargeMode: 1 // default is monitor only
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    call: {
      type: Object,
      require: true
    },
    owner: {
      type: Object,
      require: true
    }
  },
  computed: {
    MMonitor: () => 1, // monitor mode
    MFullBrg: () => 2, // full barge-in mode
    MWLegLcl: () => 3, // wisper to local leg (buddy card owner)
    MWLegRmt: () => 4, // wisper to remote leg
    opts: function () {
      return [
        {
          val: this.MMonitor,
          icon: 'microphone-off',
          hlp: 'bargein.monitor',
          lbl: this.$t('buddy.bargein.monitor')
        },
        {
          val: this.MFullBrg,
          icon: 'account-voice',
          hlp: 'bargein.full',
          lbl: this.$t('buddy.bargein.fullBarge')
        },
        {
          val: this.MWLegRmt,
          icon: 'account-arrow-up-outline',
          hlp: 'bargein.whisper',
          lbl: this.$t('buddy.bargein.whisper', [this.call.user])
        },
        {
          val: this.MWLegLcl,
          icon: 'account-arrow-up',
          hlp: 'bargein.whisper',
          lbl: this.$t('buddy.bargein.whisper', [this.owner.exten])
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      chanspy: 'sipua/chanspy'
    }),
    cancel () {
      this.$emit('cancel')
    },
    start () {
      let chan = this.call.astchan
      let num = this.call.user
      let legnum = this.owner.exten
      let mode = 'monitor'
      switch (this.bargeMode) {
        case this.MFullBrg:
          mode = 'fullbarge'
          break
        case this.MWLegRmt:
          mode = 'whisper'
          chan = this.call.srcAstchan
          break
        case this.MWLegLcl:
          num = this.owner.exten
          legnum = this.call.user
          mode = 'whisper'
          break
        case this.MMonitor: // default is monitor
        default:
          break
      }
      this.dbg(`channel to spy ${num}, legnum ${legnum} "${chan}" with mode "${mode}"`)
      this.chanspy({ num, chan, mode, legnum })
      this.cancel()
    }
  }
}
</script>

<style scoped>
</style>
